export const currencyFormatter = (currencyCode = 'AUD', price: number, maximumFractionDigits = 0) => {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: currencyCode,
    maximumFractionDigits,
  }).format(price);
};
